import React, { memo, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';
import '../../css/Messages.css';
import GraphemeSplitter from 'grapheme-splitter';
import { useDispatch, useSelector } from 'react-redux';
import { inboxActions } from '../../_store/inbox.slice';
import { showAlert } from '../../components/common/showAlert';
import TranslateFile from '../../Loc/TranslateFile';
import Loader from '../../components/common/Loader';
import { useState } from 'react';
import { getStoredValue } from "../../_helpers/storageHelper";

const PaymentModal = ({
  show,
  onClose,
  formData,
  SendMessage,
  setFormData,
  selectedMessage = '',
  CactasServiceDetailsResult
}) => {
  const newGuid = uuidv4();
  const storedloginResponse = getStoredValue("loginResponse");
  const dispatch = useDispatch();
  const currentLang = TranslateFile();
  const [loading, setloading] = useState(false);
  const [balanceValue, setbalance] = useState(0);
  const { isSignalRData } = useSelector((state) => state.auth);
  const { MyContactsDisplayForEcardDetails } = useSelector(state => state.E_Card);


  useEffect(() => {
    if (formData?.isEard) {
      calculateTotalECardCost()
    }
    else {
      calculateTotalCost();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData?.writeMessage, formData?.facilityEmojiCost, formData?.facilityMessageCost, selectedMessage?.DebitCostOfFacility]);

  useEffect(() => {
    setloading(true);
    isEmojiEnableCheck();
  }, []);

  const handleFreeCreditBalanceCHeck = () => {
    dispatch(inboxActions.LoadInmateFreeCreditBalanceResult({
      inmateResidentID: storedloginResponse?.InmatesResdId,
      facilityId: storedloginResponse?.facilityID,
    })).then((x) => {
      if (x.payload?.length > 0) {
        const { InmateFreeCreditAmount, FreeCreditActiveStatus } = x.payload[0];
        setFormData(prevFormData => ({
          ...prevFormData,
          freeCredits: InmateFreeCreditAmount,
          freeCreditStatus: FreeCreditActiveStatus === 1
        }));
      }
    })
  }

  const handlePUBalanceCheck = () => {
    const SelectUser = MyContactsDisplayForEcardDetails?.find(
      x => x?.PublicUserEmail === formData?.user);
    if (SelectUser?.PublicUserID || formData?.PublicUserID) {
      dispatch(inboxActions.LoadInmatePublicCreditBalanceResult({
        inmatesId: storedloginResponse?.InmateID,
        userId: SelectUser?.PublicUserID || formData?.PublicUserID || 0,
        pUIConnectionID: SelectUser?.PUIConnectionID || 0,
      })).then((x) => {
        if (x?.payload?.length > 0) {
          setFormData(prevFormData => ({
            ...prevFormData,
            userCredits: x?.payload[0].CreditBalance
          }));
        }
      })
    }
  }


  // useEffect(() => {
  //   if (isSignalRData?.type == "Update_Payment_Det") {
  //     isEmojiEnableCheck();
  //     handleFreeCreditBalanceCHeck();
  //     handlePUBalanceCheck();
  //   }
  // }, [isSignalRData]);

  const removeDuplicates = (arr) => {
    const unique = [];
    const emojiRegex = /\p{Emoji}/u;
    arr.forEach(element => {
      if (emojiRegex.test(element) && !unique.includes(element)) {
        unique.push(element);
      }
    });
    return unique;
  };

  const isEmojiEnableCheck = () => {
    const msgContent = formData?.isEard ? formData?.subject : formData?.writeMessage || '';
    const cleanedMsgContent = msgContent.replace(/[0-9#]/g, '');
    const splitter = new GraphemeSplitter();
    const graphemes = splitter.splitGraphemes(cleanedMsgContent);
    const uniqueEmojis = removeDuplicates(graphemes);
    const uniqueEmojiCount = uniqueEmojis?.length || 0;

    const totalEmojiCost = formData?.facilityEmojiCost * uniqueEmojiCount;
    dispatch(inboxActions.LoadCactasServiceDetailsResult({ facilityId: storedloginResponse?.facilityID })).then((response) => {
      if (response?.payload?.length > 0) {
        if (response?.payload[0]?.IsEmojiEnabled == false && totalEmojiCost > 0) {
          onClose();
          showAlert(
            null,
            currentLang?.AlertPopup?.Message,
            currentLang?.AlertPopup?.No_Longer_Emoji_Access,
            "error",
          );
        }
        let result = response.payload;
        if (result?.length > 0 && result[0].IsInmateCactasCredit === 1) {
          const { CactasURL, CactasAccessKey, FacilityEmojiCost } = result[0];
          setFormData(prevFormData => ({
            ...prevFormData,
            facilityEmojiCost: FacilityEmojiCost
          }));
          const residentID = storedloginResponse?.InmatesResdId;
          dispatch(inboxActions.LoadInmateBalance({ cactasURL: CactasURL, cactasAccessKey: CactasAccessKey, residentID: residentID })).then((x) => {
            if (x?.payload == -1) {
              setloading(false); 
             //  onClose();
              // showAlert(
              //   null,
              //   currentLang?.AlertPopup?.Message,
              //   "An internal error has occurred. Please contact the administrator.",
              //   "error",
              // );
            }
            else if (x?.payload) {
              const balanceValue = parseFloat(x?.payload) || 0;
              setbalance(Math.round(balanceValue * 100) / 100);
              setFormData(prevFormData => ({
                ...prevFormData,
                balance: Math.round(balanceValue * 100) / 100
              }));
            }
            setloading(false);
          });
        }
        else {
          setloading(false);
        }
      }
      else {
        setloading(false);
      }
    });
  };


  const calculateTotalCost = () => {
    const msgContent = formData?.writeMessage || '';
    const cleanedMsgContent = msgContent.replace(/[0-9#]/g, '');
    const splitter = new GraphemeSplitter();
    const graphemes = splitter.splitGraphemes(cleanedMsgContent);
    const uniqueEmojis = removeDuplicates(graphemes);
    const uniqueEmojiCount = uniqueEmojis?.length || 0;

    const totalEmojiCost = formData?.facilityEmojiCost * uniqueEmojiCount;
    const totalMessageCost = (formData?.facilityMessageCost || 0) + totalEmojiCost;

    if (selectedMessage?.DebitCostOfFacility) {
      const codCost = parseFloat(selectedMessage?.DebitCostOfFacility);
      const msgCostValue = parseFloat(formData?.facilityMessageCost);
      if (codCost > msgCostValue) {
        const calculatedEmojiCost = codCost - msgCostValue;
        setFormData(prevFormData => ({
          ...prevFormData,
          totalEmojiCost: calculatedEmojiCost,
          totalMessageCost: msgCostValue,
          showTotalMessageCost: true,
        }));
      }
      else {
        setFormData(prevFormData => ({
          ...prevFormData,
          showTotalMessageCost: false,
        }));
      }
    }
    else {
      setFormData(prevFormData => ({
        ...prevFormData,
        totalEmojiCost: totalEmojiCost,
        totalMessageCost: totalMessageCost,
        showTotalMessageCost: totalEmojiCost == 0 ? false : true,
      }));
    }
  };

  const calculateTotalECardCost = () => {
    const msgContent = formData?.subject || '';
    const cleanedMsgContent = msgContent.replace(/[0-9#]/g, '');
    const splitter = new GraphemeSplitter();
    const graphemes = splitter.splitGraphemes(cleanedMsgContent);
    const uniqueEmojis = removeDuplicates(graphemes);
    const uniqueEmojiCount = uniqueEmojis?.length || 0;

    const totalEmojiCost = formData?.facilityEmojiCost * uniqueEmojiCount;
    const totalMessageCost = (formData?.ecardCost || 0) + totalEmojiCost;

    setFormData(prevFormData => ({
      ...prevFormData,
      totalEmojiCost: totalEmojiCost,
      totalMessageCost: totalMessageCost,
      showTotalMessageCost: totalEmojiCost == 0 ? false : true,
    }));

  };


  return (
    <>
      {loading && <Loader />}
      <Modal show={show} onHide={onClose} backdrop="static" centered className='modal-lg'>
        <Modal.Header closeButton>
          <Modal.Title>{currentLang?.Messages?.Select_Account_for_Payment}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {(formData?.showTotalMessageCost && !formData?.isEard) && (
            <div className="total-cost-display">
              {currentLang?.Messages?.Total_Cost}  <strong>${(formData?.facilityMessageCost + formData?.totalEmojiCost)?.toFixed(2)}</strong> ({currentLang?.Messages?.Message_Cost} <strong>${parseFloat(formData?.facilityMessageCost || 0).toFixed(2)}</strong> + {currentLang?.Messages?.Emoji_Cost} <strong>${parseFloat(formData?.totalEmojiCost || 0).toFixed(2)}</strong>)
            </div>
          )}
          {(formData?.showTotalMessageCost && formData?.isEard) && (
            <div className="total-cost-display">
              {currentLang?.Messages?.Total_Cost} <strong>${(formData?.ecardCost + formData?.totalEmojiCost)?.toFixed(2)}</strong> ({currentLang?.Messages?.ECard_Cost} <strong>${parseFloat(formData?.ecardCost || 0).toFixed(2)}</strong> + {currentLang?.Messages?.Emoji_Cost} <strong>${parseFloat(formData?.totalEmojiCost || 0).toFixed(2)}</strong>)
            </div>
          )}
          <div className="d-flex flex-column flex-md-row align-items-stretch">
            {CactasServiceDetailsResult?.IsInmateCactasCredit == 1 && <Button disabled={loading} variant="danger" onClick={() => SendMessage('3', newGuid, balanceValue)} className="me-2 payment-button">
              {currentLang?.Messages?.COMMISSARY_FUNDS} <br /> {currentLang?.Messages?.Balance} <span className='fw-700'>${parseFloat(balanceValue || 0).toFixed(2)}</span>
            </Button>}
            {formData?.freeCreditStatus && (
              <Button disabled={loading} variant="success" className="payment-button me-2" onClick={() => SendMessage('2', '', balanceValue)}>
                {currentLang?.Messages?.FREE_CREDITS} <br /> {currentLang?.Messages?.Balance} <span className='fw-700'>${parseFloat(formData?.freeCredits || 0).toFixed(2)}</span>
              </Button>
            )}
            <Button disabled={loading} variant="secondary" className="payment-button me-2" onClick={() => SendMessage('1', '', balanceValue)}>
              {currentLang?.Messages?.PUBLIC_USER_CREDITS} <br /> {currentLang?.Messages?.Balance} <span className='fw-700'>${parseFloat(formData?.userCredits || 0).toFixed(2)}</span>
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default memo(PaymentModal);
